module.exports = __webpack_public_path__ + "img/scan.c86507b9.png";